/* docs */
import { cfg } from '../config';
/*--------------------------------------------------------------------------------*/
export const privacy = async () => {
    const url = 'https://cdn.jsdelivr.net/gh/wkrdev/.github/docs/privacy.md';
    const resp = await fetch(url);
    if (resp.ok) {
        return await resp.text();
    }
    return '';
};
/*--------------------------------------------------------------------------------*/
export const changelog = async (app = 'IAMSVC') => {
    const url = `/client/${app}/logs`;
    const resp = await fetch(cfg.hub.API + url);
    if (resp.ok) {
        const json = await resp.json();
        return json.data as string;
    }
    return '';
};
/*--------------------------------------------------------------------------------*/
